import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  TenderV2DTO, TenderStateDTO, TenderLotState, TenderLotV2DTO, TenderStateDTOV2,
  TenderDTO, WorkTenderDTO, TaskDTO
} from '../../api/plyca-dtos';
import { UIService } from '../../ui.service';
import { DossierService } from '../dossier.service';
import {
  ProcurementProjectDTO, EnvelopeDTO, ProcurementProjectLotDTO, CompanyDTO,
  ValidationResultDTO, ResultTypeDTO
} from '../../api/plyca-dtos-v2';
import { TaskHandler } from '../../tasks/TaskHandler';
import { finalize, flatMap, catchError, tap, map } from 'rxjs/operators';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { TenderEditorComponent } from './tenderEditor.component';
import { TenderDocumentsComponent } from './tenderDocuments.component';
import { TenderSubmissionsComponent } from './tenderSubmissions.component';
import { TenderCriteriaComponent } from './tender-criteria.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { SelectItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { TenderClassificationComponent } from '../../tasks/tenderClassification/component/tenderClassification.component';
import { TenderClassificationType } from '../../tasks/tenderClassification/model/tenderClassification.model';
import { AppConfiguration } from '../../conf/app.configuration';
import { PropertyService } from '../../properties/property.service';
import * as lodash from 'lodash';

export class TenderFilter {
  state: Array<TenderStateDTO>;
  lots: Array<ProcurementProjectLotDTO>;
  companies: Array<CompanyDTO>;
  constructor() {
    this.state = [];
    this.lots = [];
    this.companies = [];
  }
}

@Component({
  selector: 'tenderList',
  templateUrl: 'tenderList.template.html',
  providers: [DialogService]
})
export class tenderListComponent extends TaskHandler
  implements OnInit, OnDestroy {
  loaded = false;
  private modalOpened: boolean;

  // INFORMACION DEL EXPEDIENTE
  dossierId: string;
  //  dossier: DossierDTO;
  project: ProcurementProjectDTO;
  hasLots: boolean;

  tendersLoaded = false;
  tenderList: Array<TenderV2DTO>;
  filteredTenderList: Array<TenderV2DTO>;

  tenderingEnvelopes: Array<EnvelopeDTO>;

  // datos para filtros
  filter: TenderFilter;
  filterLotValues = [] as SelectItem[];
  companyValues = [];
  tenderStates: any[];
  tenderLotStates: any[];
  yesNoModel: any;

  public TenderStateDTOV2 = TenderStateDTOV2;
  public colHeaders: string[];

  // visualización de errores
  @ViewChild('tenderErrors')
  tenderErrorsPanel: OverlayPanel;
  private tenderListErrorMap = new Map<number, Array<string>>();
  public tenderListError = Array<string>();

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    protected appConfig: AppConfiguration,
    public dossierService: DossierService,
    protected configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    protected dialogService: DialogService,
    private propertyService: PropertyService
  ) {
    super();
    this.colHeaders = [
      this.translateService.instant('TenderInfo.company'),
      this.translateService.instant('General.state'),
      this.translateService.instant('TenderEvaluation.filter.lots'),
      this.translateService.instant('General.actions')
    ];
  }

  ngOnInit() {
    this.waitService.startWaiting();
    this.dossierId = this.task.division.project.identifier;
    this.tenderList = this.task.work.tenders;
    this.filteredTenderList = this.tenderList;
    this.initFilters();
    this.updateFilter();

    this.subscribe(
      forkJoin([
        this.plycaService.query<EnvelopeDTO>(this.configuration.ENVELOPE_SERVICE_URL,
          {
            procurementProjectId: this.dossierId,
            documentClassType: 'OF',
            expand: 'expansionSet:webclient'
          }),
        // this.plycaService.getProcurementProjectWithLot(this.dossierId)
        this.plycaService.get<ProcurementProjectDTO>(this.configuration.PROCUREMENTPROJ_SERVICE_URL, this.dossierId, { expand: 'expansionSet:BASIC_LOT,mapping:extended' }),
        this.propertyService.getProperty('FraExpedienteOf.BtnValoracionCriterios.Visible')
      ]).pipe(finalize(() => {
        this.loaded = true;
        this.waitService.cancelWaiting();
      })
      ),
      results => {
        // respuesta consulta de project
        // this.project = results[0];

        // sobres de la oferta
        let docs = [];
        if (results[0] && results[0].content) {
          this.tenderingEnvelopes = results[0].content;
        } else {
          this.tenderingEnvelopes = new Array<EnvelopeDTO>();
        }

        this.tenderingEnvelopes.forEach(envelope => {
          if (envelope.files) {
            envelope.files.forEach(file => {
              let docItem = {};
              docItem['description'] =
                '[' + envelope.description + '] ' + file.description;
              docItem['fileDescription'] = file.description;
              docItem['file'] = file;
              docItem['envelopeDescription'] = envelope.description;
              docItem['envelope'] = envelope;
              docs.push(docItem);
            });
          }
        });
        this.project = results[1];
        if (this.project.breakdownLot) {
          this.hasLots = this.project.breakdownLot.apportioned;
          if (this.hasLots) {
            if (this.hasLots) {
              this.project.breakdownLot.lots
                .sort((lot1, lot2) => lot1.lotNumber - lot2.lotNumber)
                .forEach(
                  (lot: ProcurementProjectLotDTO) => {
                    // añadir a combo de filtro
                    this.filterLotValues.push({ label: this.getProcurementProjectLotDescription(lot), value: lot });
                  }
                );
            }
          }
        }
        this.initHeaderActions(results[2]);
      });

    let correctedTenders = this.tenderList.find((tender: TenderV2DTO) =>
      tender.document.currentState.identifier === TenderStateDTOV2.TOCORRECT);
    if (correctedTenders && this.task) {
      // aviso indicando que existen ofertas marcadas como subsanadas
      this.uiService.showMessage(
        this.translateService.instant('TenderEvaluation.correctedTendersMsg'),
        this.translateService.instant('General.warn'));
    }
  }
  private updateFilter(): void {
    this.companyValues = this.tenderList.map((tender: TenderV2DTO) => {
      let company: CompanyDTO;
      if (tender.tendererParty.company) {
        company = lodash.clone(tender.tendererParty.company);
        company['description'] = this.getCompanyDescription(tender);
      }
      return company;
    }).sort((company1, company2) => company1['description'].localeCompare(company2['description']));
  }

  private initHeaderActions(criteriaEditionProperty: string) {
    this.headerActionsService.clearActions();
    // registrar ofertas
    if (this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.modeRegisterTendersEnabled
      && this.task.work.context.configurations.modeRegisterTendersEnabled.value) {

      this.subscribe(this.headerActionsService
        .addAction(this.translateService.instant('TenderList.actions.register'), 'fas fa-lg fa-plus', 'btn-primary', true),
        () => {
          this.openTenderEditor();
        });
    }
    // evaluacion de ofertas
    if (this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.modeEvaluateTendersEnabled
      && this.task.work.context.configurations.modeEvaluateTendersEnabled.value) {

      // accion aceptar ofertas restantes
      this.subscribe(this.headerActionsService
        .addAction('TenderEvaluation.acceptTenders',
          'fas fa-lg fa-thumbs-up',
          'btn-secondary',
          () => this.getInitialStateTenders().length > 0),
        success => {
          this.uiService.showConfirmMessage({
            message: this.translateService.instant('TenderEvaluation.acceptTendersMsg'),
            header: this.translateService.instant('General.confirmtext'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              let observableList = this.getInitialStateTenders()
                .map((tender: TenderV2DTO) => of(tender).pipe(
                  flatMap((tenderFromObservable: TenderV2DTO) => this.patchTenderState(tenderFromObservable.identifier,
                    TenderStateDTO.ACCEPTED)),
                  catchError((error: any) => {
                    console.log('Error al aceptar oferta ', tender);
                    return of(tender);
                  })));
              this.waitService.startWaiting();
              this.subscribe(forkJoin(observableList).pipe(finalize(() => this.reload())));
            },
            reject: () => undefined
          });
        });
      if (criteriaEditionProperty === '1') {
        // edición de criterios
        this.subscribe(this.headerActionsService
          .addAction(this.translateService.instant('TenderList.actions.criteria'), 'fas fa-pencil-ruler', 'btn-secondary', true),
          () => {
            this.editTenderCriterias();
          });
      }
      let cliente = this.appConfig.getValue('cliente');
      if ('AYMAD' === cliente && this.task?.work?.context?.configurations?.visibleTenderClassificationButton?.value) {
        this.subscribe(this.headerActionsService
          .addAction(this.translateService.instant('Clasificación de ofertas'), 'fas fa-lg fa-list-ol', 'btn-secondary', true),
          () => {
            this.openTenderClassification();
          });
      }
    }
    // actualizar
    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-lg fa-sync-alt', 'btn-secondary', true),
      () => {
        this.reload();
      });
    this.headerActionsService.addDivider();
    // procesar tarea
    this.subscribe(this.headerActionsService
      .addAction('General.accept', 'fas fa-check', 'btn-outline-secondary', true),
      () => {
        this.processTask();
      });
  }

  ngOnDestroy(): void {
    this.dialogService = null;
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  editTenderCriterias() {
    let config: DynamicDialogConfig = {
      header: '',
      width: '80%',
      style: { overflow: 'hiden', 'max-height': '80vh' },
      styleClass: 'searchStyle'
    };

    config.data = {
      'project': this.project,
    }
    this.modalOpened = true;
    this.waitService.startWaiting();
    let modal = this.dialogService.open(TenderCriteriaComponent, config);
    this.subscribe(modal.onClose, () => this.modalOpened = false,
      (error: any) => {
        console.error(error);
        this.modalOpened = false;
      })
  }

  openTenderClassification() {
    let config: DynamicDialogConfig = {
      header: 'Clasificación de ofertas',
      width: '80%',
      style: { overflow: 'hiden', 'max-height': '80vh' },
      styleClass: 'searchStyle'
    };

    config.data = {
      'project': this.project,
      'tenderClassificationType': TenderClassificationType.CLASIFICAR
    }
    this.modalOpened = true;
    this.waitService.startWaiting();
    let modal = this.dialogService.open(TenderClassificationComponent, config);
    this.subscribe(modal.onClose, () => this.modalOpened = false,
      (error: any) => {
        console.error(error);
        this.modalOpened = false;
      })
  }

  /**
   * Método que lanza la misma validacion que realiza el WorkTender en servidor
   * antes de despachar para poder mostrar errores antes de ventana Mantener/Despachar
   *
   */
  private isValidTaskWorkValidation(): Observable<boolean> {
    // validar work
    let url = '/userAPI/v1/tasks/' + this.task.identifier + '/tenders/';
    this.waitService.startWaiting();
    let obs = this.plycaService.validate<WorkTenderDTO>(url, 'Completed', this.task.work).pipe(
      map((validation: ValidationResultDTO) => {
        if (validation.result === ResultTypeDTO.OK) {
          this.tenderListErrorMap.clear();
          return true;
        } else {
          this.showValidationError(validation);
          return false;
        }
      }),
      catchError((error: any) => {
        this.manageHttpError(error);
        return of(false);
      })
    );
    return obs;
  }

  processTask(reactivate = false) {
    // validar work
    let url = '/userAPI/v1/tasks/' + this.task.identifier + '/tenders/';
    this.waitService.startWaiting();
    this.subscribe(this.isValidTaskWorkValidation().pipe(
      tap((validTask: boolean) => {
        if (validTask) {
          super.processTask(reactivate);
        } else {
          this.waitService.startWaiting();
          this.confirmationService.confirm({
            message: this.translateService.instant('TenderList.errors.validations'),
            accept: () => {
              this.mantainTask();
            },
            reject: () => this.waitService.cancelWaiting()
          });
        }
      }),
      finalize(() => this.waitService.cancelWaiting())
    )
    );
  }

  manageHttpError(error: any): Observable<any> {
    if (this.formService.isValidationResponse(error)) {
      let validation = error.error as ValidationResultDTO;
      this.showValidationError(validation);
      return of();
    } else {
      return throwError(error);
    }
  }

  showValidationError(validationResult: ValidationResultDTO) {
    this.tenderListErrorMap.clear();
    if (validationResult.errors) {
      let errorRegex = /^tenders\[(\d+)\]/;
      // extraer índices de las
      validationResult.errors.forEach(validation => {
        let matches = validation.jsonPath && validation.jsonPath.match(errorRegex);
        if (matches) {
          let errorIndex = parseInt(matches[1]);
          let errors = this.tenderListErrorMap.get(errorIndex);
          if (!errors) {
            this.tenderListErrorMap.set(errorIndex, []);
          }
          errors = this.tenderListErrorMap.get(errorIndex);
          if (errors.indexOf(validation.message) === -1) {
            //eliminar mensajes duplicados
            errors.push(validation.message);
          }
        }
      })
    }
  }

  private mantainTask(): void {
    this.subscribeObserver(this.taskService.saveWork(this.task).pipe(
      tap((updatedTask: TaskDTO) => {
        this.task = updatedTask;
        this.validaCierreVentana = false;
        this.salir();
      })),
      {
        error: (error: any) => {
          console.error(error);
          this.plycaErrorHandler.showServerError(error);
        }
      });
  }

  private getInitialStateTenders(): TenderV2DTO[] {
    let initialStateTenderList: TenderV2DTO[];
    if (this.tenderList) {
      initialStateTenderList = this.tenderList.filter((tender: TenderV2DTO) => tender.document
        && tender.document.currentState
        && tender.document.currentState.identifier === TenderStateDTOV2.INITIAL)
    }
    return initialStateTenderList;
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  initFilters() {
    this.filter = new TenderFilter();

    this.tenderStates = [
      { label: this.translateService.instant('TenderStateDTO.INITIAL'), value: this.TenderStateDTOV2.INITIAL },
      { label: this.translateService.instant('TenderStateDTO.ACCEPTED'), value: this.TenderStateDTOV2.ACCEPTED },
      { label: this.translateService.instant('TenderStateDTO.REJECTED'), value: this.TenderStateDTOV2.REJECTED },
      { label: this.translateService.instant('TenderStateDTO.CORRECTED'), value: this.TenderStateDTOV2.TOCORRECT }
    ];
    this.tenderLotStates = [
      { label: this.translateService.instant('TenderLotState.ADMITTED'), value: TenderLotState.ADMITTED },
      { label: this.translateService.instant('TenderLotState.REJECTED'), value: TenderLotState.REJECTED },
      { label: this.translateService.instant('TenderLotState.EXCLUDED'), value: TenderLotState.EXCLUDED }
    ];
    this.yesNoModel = [
      { label: this.translateService.instant('General.yes'), value: true },
      { label: this.translateService.instant('General.no'), value: false }
    ];
  }

  public filterTenderList() {
    let results = this.tenderList;
    if (this.filter.state.length > 0) {
      results = results
        .filter((tender: TenderV2DTO) => this.filter.state
          .find((state: TenderStateDTO) => tender.document && tender.document.currentState
            && state === tender.document.currentState.identifier));
    }
    if (this.filter.lots.length > 0) {
      results = results
        .filter((tender: TenderV2DTO) => this.filter.lots
          .find((lot: ProcurementProjectLotDTO) => this.tenderIncludesLot(tender, lot)));
    }
    if (this.filter.companies.length > 0) {
      results = results
        .filter((tender: TenderV2DTO) => this.isCompanySelected(tender));
    }
    this.filteredTenderList = results;
  }


  private isCompanySelected(tender: TenderV2DTO): boolean {
    return this.filter.companies.find((company: CompanyDTO) => company?.identifier === tender?.tendererParty?.company?.identifier)
      !== undefined;
  }

  public getCompanyDescription(tender: TenderV2DTO): string {
    let description: string;
    if (tender.tendererParty.company) {
      description = CompanyDTO.getCompanyDescription(tender.tendererParty.company);
    }
    return description || '';
  }

  private tenderIncludesLot(tender: TenderV2DTO, lot: ProcurementProjectLotDTO): boolean {
    return tender.tenderLots
      && tender.tenderLots
        .find((tenderLot: TenderLotV2DTO) => tenderLot.procurementProjectLot.lotId == lot.lotId
        ) !== undefined;
  }

  private getProcurementProjectLotDescription(projectLot: ProcurementProjectLotDTO): string {
    return (projectLot) ? projectLot.lotNumber + '-' + projectLot.description : '-';
  }


  openTenderEditor(tender?: TenderV2DTO, index?: number) {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TenderList.actions.editTender'),
      width: '80%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let invalidTender = index !== undefined && this.isTenderInError(index);
    config.data = {
      task: this.task,
      project: this.project,
      invalid: invalidTender,
      readOnly: !this.task?.work?.context?.configurations?.modeRegisterTendersEnabled?.value
        && !this.task?.work?.context?.configurations?.modeEnvelopeOpeningEnabled?.value
        && this.task?.work?.context?.configurations?.modeEvaluateTendersEnabled?.value
    };
    if (tender) {
      config.data.id = tender.identifier;
    }
    this.modalOpened = true;
    this.subscribe(this.dialogService.open(TenderEditorComponent, config).onClose,
      (tenderSaved: boolean) => {
        this.modalOpened = false;
        this.reloadAndValidate(tenderSaved);
      },
      (error: any) => {
        console.error(error);
        this.modalOpened = false;
      });
  }

  private reloadAndValidate(tenderSaved: boolean) {
    this.subscribe(this.reloadObservable(),
      () => {
        if (tenderSaved) {
          this.subscribe(this.isValidTaskWorkValidation(),
            () => this.waitService.cancelWaiting(),
            (error: any) => {
              this.plycaErrorHandler.showServerError(error);
              this.waitService.cancelWaiting();
            });
        }
      });
  }

  reload() {
    this.waitService.startWaiting();
    this.subscribe(this.reloadObservable());
  }

  private reloadObservable(): Observable<any> {
    this.waitService.startWaiting();
    return this.taskService.getTaskForWork(this.task.identifier).pipe(
      tap(_task => {
        this.task = _task;
        this.tenderList = this.task.work.tenders;
        this.updateFilter();
        this.filterTenderList();
        this.waitService.cancelWaiting();
      })
    );
  }

  public openTenderDocuments(tender: TenderV2DTO, index?: number) {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('Documents.title') + ' ' + CompanyDTO.getCompanyDescription(tender.tendererParty.company),
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'searchStyle'
    };
    config.data = {
      id: tender.identifier,
      task: this.task,
      project: this.project
    }
    this.modalOpened = true;
    this.subscribe(this.dialogService.open(TenderDocumentsComponent, config).onClose,
      (updatedTender) => {
        this.modalOpened = false;
        this.reloadAndValidate(updatedTender);
      },
      (error: any) => {
        console.error(error);
        this.modalOpened = false;
      });
  }

  openTenderSubmissions(tender: TenderV2DTO): void {

    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TenderInfo.companySubmission', { company: this.getCompanyDescription(tender) }),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle',
      closeOnEscape: false,
      closable: true,
      data: {
        id: tender.identifier,
        tender: tender,
        task: this.task,
        project: this.project
      }
    };
    this.modalOpened = true;
    this.subscribe(this.dialogService.open(TenderSubmissionsComponent, config).onClose,
      (result: any) => {
        this.modalOpened = false;
        if (result && result.reloadTenderList) {
          this.reload();
        }
      },
      (error: any) => {
        console.error(error);
        this.modalOpened = false;
      });
  }

  public deleteTender(tender: TenderV2DTO): void {
    this.confirmationService.confirm({
      message: this.translateService.instant('General.confirm.action.delete'),
      accept: () => {
        this.subscribe(this.plycaService.delete<TenderV2DTO>(this.configuration.TENDER_SERVICE_V2_URL, tender.identifier),
          () => this.reload(),
          (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }
    });
  }

  private patchTenderState(tenderIdentifier: string, state: TenderStateDTO): Observable<any> {
    let patchedTender = new TenderDTO();
    patchedTender.identifier = tenderIdentifier;
    patchedTender.state = state
    return this.plycaService.patch<TenderDTO>(
      this.configuration.TENDER_SERVICE_URL,
      patchedTender
    );
  }

  public getTenderLotsDescription(tender: TenderV2DTO) {
    let description = '';
    if (tender.tenderLots) {
      let separator = '';
      tender.tenderLots.forEach((tenderLot: TenderLotV2DTO) => {
        let lotDef = this.filterLotValues
          .find((lotItem: SelectItem) => lotItem.value.lotId === tenderLot.procurementProjectLot.lotId
            || lotItem.value.lotNumber === tenderLot.procurementProjectLot.lotNumber);
        if (lotDef) {
          description += separator + lotDef.label;
          separator = ', '
        }
      })
    }
    return description;
  }


  /**
   * Impedir salir si hay modal abierta
   */
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.modalOpened) {
      return super.canDeactivate();
    }
    return false;
  }

  public existsErrors(): boolean {
    return this.tenderListErrorMap.size > 0;
  }
  public isTenderInError(index: number): boolean {
    return this.tenderListErrorMap.get(index) !== undefined;
  }

  public showErrors(event: any, target: any, index: number): void {
    this.tenderListError = this.tenderListErrorMap.get(index);
    this.tenderErrorsPanel.appendTo = (target) ? target : 'body';
    this.tenderErrorsPanel.show(event, target);
  }

  public toggleErrors(event: any, target: any, index: number): void {
    this.tenderListError = this.tenderListErrorMap.get(index);
    this.tenderErrorsPanel.appendTo = (target) ? target : 'body';
    this.tenderErrorsPanel.toggle(event, target);
  }

  public hideErrors(): void {
    this.tenderListError = [];
    this.tenderErrorsPanel.hide();
  }

}
